import { useQuery } from '@tanstack/react-query';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

const isActive = (report: aiReportTypes.Report) =>
  report.status === 'queued' || report.status === 'running';

export const getPageReports: aiReportTypes.ListReports = (params) => {
  return axios.get('/page-reports', { params });
};

type QueryFnType = typeof getPageReports;

type UseGetPageReportsOptions = {
  filter: aiReportTypes.ListFilter;
  config?: QueryConfig<QueryFnType>;
};

export const useGetPageReports = ({ filter, config = {} }: UseGetPageReportsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['page-reports', filter],
    queryFn: () => getPageReports(filter),
    refetchInterval: (data) => (data?.reports.some(isActive) ? 4000 : false),
  });
};
